<template>
  <div class="quote-info">
    <div class="info-con">
      <div class="info-title">车主信息</div>
      <van-form @submit="onSubmit">
        <van-field name="company" label="保司"
        >
          <template #input>
            <van-dropdown-menu>
              <van-dropdown-item
                  v-model="insuranceCode"
                  :lazy-render="false"
                  :options="companys"
              />
            </van-dropdown-menu>
          </template>
        </van-field>
        <van-field
            v-model="name"
            name="姓名"
            label="姓名"
            placeholder="姓名"
            :rules="[{ required: true, message: '请填写姓名' }]"
        />
        <van-field
            v-model="idCard"
            name="身份证"
            label="身份证"
            placeholder="身份证"
            maxlength="18"
            :rules="[
            { required: true, message: '请填写身份证' },
            { validator, message: '身份证格式错误！' },]"
        />
        <van-field
            v-model="phoneNo"
            name="联系电话"
            label="联系电话"
            placeholder="联系电话"
            maxlength="11"
            :rules="[{ required: true, message: '请填写联系电话' },{ pattern: /^1[3456789]\d{9}$/, message: '手机号码格式错误！'}]"
        />
        <van-field
            v-model="residence"
            name="通讯地址"
            label="通讯地址"
            placeholder="通讯地址"
            :rules="[{ required: true, message: '请填写通讯地址' }]"
        />
        <van-field
            v-model="remark"
            name="备注"
            label="备注"
            placeholder="描述三者险保额以及其他需求"
            :rules="[{ required: true, message: '请填写备注' }]"
        />
        <div class="quote-li">
          <li>请上传投保人的身份证与投保车辆的行驶影像资料。</li>
          <li>请确保上传影像清晰完整无任何遮挡，同时避免反光，尽量让证件照占满屏幕，并且露出证件边缘。</li>
        </div>
        <div class="img-upload">
          <div class="div-title">车辆行驶证</div>
          <div class="upload-div">
            <div class="div-box">
              <div class="box-img">
                <van-uploader style="align-content: center" max-count="1" :file-list="list1" :after-read="frontIdImg">
                  <svg-icon v-if="!frontId" icon-class="mine-identity"></svg-icon>
                </van-uploader>
              </div>
              <div class="div-title">身份证头像面</div>
            </div>
            <div class="div-box">
              <div class="box-img">
                <van-uploader style="align-content: center" max-count="1" :file-list="list2" :after-read="backIdImg">
                  <svg-icon v-if="!backId" icon-class="mine-identity"></svg-icon>
                </van-uploader>
              </div>
              <div class="div-title">身份证国徽面</div>
            </div>
          </div>
          <div class="upload-div">
            <div class="div-box">
              <div class="box-img">
                <van-uploader style="align-content: center" max-count="1" :file-list="list3"
                              :after-read="driveFrontImg">
                  <svg-icon v-if="!driveFront" icon-class="mine-identity"></svg-icon>
                </van-uploader>
              </div>
              <div class="div-title">行驶证主页</div>
            </div>
            <div class="div-box">
              <div class="box-img">
                <van-uploader style="align-content: center" max-count="1" :file-list="list4" :after-read="driveBackImg">
                  <svg-icon v-if="!driveBack" icon-class="mine-identity"></svg-icon>
                </van-uploader>
              </div>
              <div class="div-title">行驶证副页</div>
            </div>
          </div>
        </div>
        <div style="margin: 16px;">
          <van-button round block type="info" native-type="submit" color="#FF6C00">提交</van-button>
        </div>
      </van-form>
    </div>
  </div>
</template>

<script>
import URL from "@/api/api";
import {Toast} from "vant";

export default {
  data() {
    return {
      agentUserId: '',
      insuranceCode: '1',
      name: '',
      idCard: '',
      phoneNo: '',
      residence: '',
      frontId: '',
      backId: '',
      driveFront: '',
      driveBack: '',
      remark: '',
      list1: [],
      list2: [],
      list3: [],
      list4: [],
      companys: [],
    }
  },
  created() {
    this.agentUserId = this.$route.query.agentUserId;
    this.getInsuranceCompany()
  },
  methods: {
    validator(val) {
      const card15 =/^[1-9]\d{5}\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{2}[0-9Xx]$/;
      const card18 =/^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/;
      return card15.test(val) || card18.test(val);
    },
    getInsuranceCompany() {
      this.$fetchGet(URL.dictData.url, {'name': 'car_insurance_list'}).then(res => {
        this.companys = res.data.data;
      })
    },
    frontIdImg(file) {//身份证头像面
      this.afterRead(file, 1)
    },
    backIdImg(file) {//身份证国徽面
      this.afterRead(file, 2)
    },
    driveFrontImg(file) {//驾驶证主页
      this.afterRead(file, 3)
    },
    driveBackImg(file) {//驾驶证副页
      this.afterRead(file, 4)
    },
    removeImg() {

    },
    afterRead(file, flag) {
       //身份证照片console
      Toast.loading({
        message: "加载中...",
        duration: 0,
        forbidClick: true
      });
      let data = {
        bucketName: 'skjy',
        dir: 'car/',
        file: file.file
      }
      this.$fetchPost(URL.quoteImg.url, this.$toFormData(data)).then((res) => {
        if (res.data.code == 20000) {
          Toast.clear();
          if (flag == 1) {
            this.list1 = []
            this.frontId = res.data.data.fileUrl
            this.list1.push({url: this.frontId})
          }
          if (flag == 2) {
            this.list2 = []
            this.backId = res.data.data.fileUrl
            this.list2.push({url: this.backId})
          }
          if (flag == 3) {
            this.list3 = []
            this.driveFront = res.data.data.fileUrl
            this.list3.push({url: this.driveFront})
          }
          if (flag == 4) {
            this.list4 = []
            this.driveBack = res.data.data.fileUrl
            this.list4.push({url: this.driveBack})
          }
        } else if (res.data.code == 9999) {
          Toast('识别失败，请重新上传证件照')
        }
      })
    },
    onSubmit() {
      let data = {
        cusUserId: localStorage.getItem("userid"),
        agentId: this.agentUserId,
        remark: this.remark,
        name: this.name,
        idCard: this.idCard,
        insuranceCode: this.insuranceCode,
        phoneNo: this.phoneNo,
        residence: this.residence,
        frontIdImg: this.frontId,
        backIdImg: this.backId,
        driveFrontImg: this.driveFront,
        driveBackImg: this.driveBack

      }
      if(this.frontId==''){
        Toast('请上传身份证头像面')
      }else if(this.backId==''){
        Toast('请上传身份证国徽面')
      }else if(this.driveFront==''){
        Toast('请上传行驶证主页')
      }else if(this.driveBack==''){
        Toast('请上传行驶证副页')
      }
      else{
        this.$fetchPost(URL.quotePro.url, data).then(res => {
        if (res.data.code == 20000) {
          this.$router.push("/productTC")
        }else{
          Toast(res.data.msg)
        }
      })
      }
    }
  }
}
</script>

<style lang="less" scoped>
.quote-info {
  width: 100%;
  height: 100vh;
  overflow: scroll;
  background: #ededed;

  /deep/ .van-dropdown-menu {
    width: 100%;

    .van-dropdown-menu__bar {
      height: auto;
      box-shadow: none;

      .van-dropdown-menu__title {
        width: 100%;
      }
    }
  }

  .info-con {
    margin: 20px;

    .quote-li {
      //   margin: 20px 0;
      font-size: 13px;

      li:before {
        content: "";
        display: inline-block;
        width: 8px;
        height: 8px;
        background-color: #FF6C00;
        border-radius: 50%;
        margin-right: 15px;
      }

      li {
        margin-top: 1px;
        letter-spacing: 2px;
        list-style: none;
      }
    }

    .img-upload {
      .div-title {
        font-size: 14px;
        text-align: center;
      }

      .upload-div {
        display: flex;
        justify-content: space-between;
      }

      .div-box {
        width: 160px;
        margin-top: 20px;

        /deep/ .box-img {
          width: 160px;
          height: 90px;

          .svg-icon {
            height: 80px;
          }

          .van-uploader__preview {
            margin: auto;
          }

          .van-uploader__preview-image {
            width: 160px;
          }
        }
      }
    }

    .info-title {
      text-align: center;
      margin: 10px 0;
      font-size: 14px;
    }
  }
}

</style>
